var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSquaresRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2.75C3.01088 2.75 2.75 3.01088 2.75 3.33333V5.16667C2.75 5.48912 3.01088 5.75 3.33333 5.75H5.16667C5.48912 5.75 5.75 5.48912 5.75 5.16667V3.33333C5.75 3.01088 5.48912 2.75 5.16667 2.75H3.33333ZM1.25 3.33333C1.25 2.18245 2.18245 1.25 3.33333 1.25H5.16667C6.31755 1.25 7.25 2.18245 7.25 3.33333V5.16667C7.25 6.31755 6.31755 7.25 5.16667 7.25H3.33333C2.18245 7.25 1.25 6.31755 1.25 5.16667V3.33333Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 2.75C10.5109 2.75 10.25 3.01088 10.25 3.33333V5.16667C10.25 5.48912 10.5109 5.75 10.8333 5.75H12.6667C12.9891 5.75 13.25 5.48912 13.25 5.16667V3.33333C13.25 3.01088 12.9891 2.75 12.6667 2.75H10.8333ZM8.75 3.33333C8.75 2.18245 9.68245 1.25 10.8333 1.25H12.6667C13.8175 1.25 14.75 2.18245 14.75 3.33333V5.16667C14.75 6.31755 13.8175 7.25 12.6667 7.25H10.8333C9.68245 7.25 8.75 6.31755 8.75 5.16667V3.33333Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 10.25C3.01088 10.25 2.75 10.5109 2.75 10.8333V12.6667C2.75 12.9891 3.01088 13.25 3.33333 13.25H5.16667C5.48912 13.25 5.75 12.9891 5.75 12.6667V10.8333C5.75 10.5109 5.48912 10.25 5.16667 10.25H3.33333ZM1.25 10.8333C1.25 9.68245 2.18245 8.75 3.33333 8.75H5.16667C6.31755 8.75 7.25 9.68245 7.25 10.8333V12.6667C7.25 13.8175 6.31755 14.75 5.16667 14.75H3.33333C2.18245 14.75 1.25 13.8175 1.25 12.6667V10.8333Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 10.25C10.5109 10.25 10.25 10.5109 10.25 10.8333V12.6667C10.25 12.9891 10.5109 13.25 10.8333 13.25H12.6667C12.9891 13.25 13.25 12.9891 13.25 12.6667V10.8333C13.25 10.5109 12.9891 10.25 12.6667 10.25H10.8333ZM8.75 10.8333C8.75 9.68245 9.68245 8.75 10.8333 8.75H12.6667C13.8175 8.75 14.75 9.68245 14.75 10.8333V12.6667C14.75 13.8175 13.8175 14.75 12.6667 14.75H10.8333C9.68245 14.75 8.75 13.8175 8.75 12.6667V10.8333Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquaresRegular);
export default __webpack_public_path__ + "static/media/icon-squares-regular.50f28fd2c053d777ce5e13e050062b41.svg";
export { ForwardRef as ReactComponent };